import React from "react";
import { ShieldCheck, Lock, FileText, Eye, Database } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="  bg-gradient-to-b from-gray-50 to-white text-gray-800">
      {/* Hero Section */}
      <section className="bg-blue-900 w-full h-[65vh] text-white py-24 px-6 text-center relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=2070&auto=format&fit=crop"
            alt="Live Chat Support Team"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Gradient Right Blur Effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

        <div className="relative z-10">
          <ShieldCheck className="mx-auto mb-6" size={50} />
          <h1 className="text-4xl md:text-5xl font-bold mb-4 ">
            Privacy Policy
          </h1>
          <p className="text-blue-100 max-w-2xl mx-auto text-lg">
            Suraksha 24/7 is committed to protecting your privacy and securing
            your personal information.
          </p>
          <p className="mt-4 text-sm text-blue-200">Effective Date:</p>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-6 py-20 space-y-16">
        {/* Introduction */}
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <div className="flex items-center gap-4 mb-4">
            <FileText className="text-blue-800" size={28} />
            <h2 className="text-2xl font-bold text-blue-900">Introduction</h2>
          </div>
          <p className="leading-relaxed text-gray-700">
            At Suraksha 24/7, we value your trust. As a provider of CCTV and
            surveillance solutions, we understand the importance of protecting
            your personal information. This Privacy Policy explains how we
            collect, use, and safeguard your data when you use our website or
            services.
          </p>
        </div>

        {/* Information Collection */}
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <div className="flex items-center gap-4 mb-6">
            <Database className="text-blue-800" size={28} />
            <h2 className="text-2xl font-bold text-blue-900">
              Information We Collect
            </h2>
          </div>

          <ul className="space-y-4 text-gray-700">
            <li>• Name, email address, phone number</li>
            <li>• Installation or billing address</li>
            <li>• Order and warranty details</li>
            <li>• Website usage data (IP, browser type, pages visited)</li>
          </ul>
        </div>

        {/* Usage */}
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <div className="flex items-center gap-4 mb-4">
            <Eye className="text-blue-800" size={28} />
            <h2 className="text-2xl font-bold text-blue-900">
              How We Use Your Information
            </h2>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li>• Respond to inquiries and service requests</li>
            <li>• Process orders and installations</li>
            <li>• Provide customer support</li>
            <li>• Improve our services and website performance</li>
            <li>• Send important service-related updates</li>
          </ul>
        </div>

        {/* CCTV Responsibility */}
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <div className="flex items-center gap-4 mb-4">
            <ShieldCheck className="text-blue-800" size={28} />
            <h2 className="text-2xl font-bold text-blue-900">
              CCTV Data Responsibility
            </h2>
          </div>
          <p className="leading-relaxed text-gray-700">
            Suraksha 24/7 installs and supplies CCTV systems. We do not monitor
            your premises or access recorded footage unless requested for
            technical support. Customers are responsible for lawful use of
            surveillance systems.
          </p>
        </div>

        {/* Security */}
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <div className="flex items-center gap-4 mb-4">
            <Lock className="text-blue-800" size={28} />
            <h2 className="text-2xl font-bold text-blue-900">
              Data Protection & Security
            </h2>
          </div>
          <p className="leading-relaxed text-gray-700">
            We implement security measures such as SSL encryption, secure
            hosting servers, restricted internal access, and regular monitoring
            to protect your information from unauthorized access.
          </p>
        </div>

        {/* Retention */}
        <div className="bg-white shadow-lg rounded-2xl p-8">
          <h2 className="text-2xl font-bold text-blue-900 mb-4">
            Data Retention
          </h2>
          <p className="leading-relaxed text-gray-700">
            We retain personal information only for as long as necessary to
            provide services, fulfill legal obligations, and maintain business
            records. After this period, data is securely deleted.
          </p>
        </div>

        {/* Contact */}
        <div className="bg-blue-900 text-white rounded-2xl p-10 text-center shadow-xl">
          <h2 className="text-2xl font-bold mb-4">Contact Suraksha 24/7</h2>
          <p>Email: support@suraksha247.com</p>
          <p>Phone: +91-XXXXXXXXXX</p>
          <p>Address: [Your Office Address]</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
